import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './Login.css';

const DevLogin = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setStatusMessage('');

    if (!username.trim() || !password) {
      setError('Username and password are required');
      return;
    }

    setLoading(true);
    const result = await login(username.trim(), password);
    setLoading(false);

    if (result.success) {
      setStatusMessage('Signed in with local credentials');
      if (typeof window !== 'undefined' && window.location.pathname.toLowerCase() === '/devlogin') {
        window.history.replaceState({}, '', '/');
      }
    } else {
      setError(result.error || 'Invalid username or password');
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Developer Login</h1>
          <p>Use local portal credentials</p>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        {statusMessage && (
          <div className="success-message">
            {statusMessage}
          </div>
        )}

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="dev-username">Username</label>
            <input
              id="dev-username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="portal username"
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="dev-password">Password</label>
            <input
              id="dev-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="portal password"
              disabled={loading}
            />
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div className="login-footer">
          <p>This page is only available on /devlogin for testing.</p>
        </div>
      </div>
    </div>
  );
};

export default DevLogin;











